import { clsx } from 'clsx';
import { EntityType } from '../../../shared/components/EntityType/EntityType';
import styles from './CreatePipelineWizardEntitySelectionDisplay.module.scss';

export function CreatePipelineWizardEntitySelectionDisplay({
  logo,
  title,
  className
}: {
  logo?: string;
  title?: string;
  className?: string;
}) {
  if (logo && title) {
    return (
      <EntityType
        logo={logo}
        logoDarkMode={logo}
        logoSize={0}
        title={title}
        className={clsx(
          'text-caption-2 justify-center bg-ripple',
          styles.displayContainer,
          className
        )}
      />
    );
  }

  if (title) {
    return <span className={clsx('text-caption-2', className)}>{title}</span>;
  }

  return null;
}
